import { Box, Typography } from '@mui/material';
import { ReactComponent as ShieldKeyIcon } from '../../../../../../../../assets/shield-key.svg';
import { RolesColumn } from '../../../../../../../../model/rolesAndPerms.model';
import zeplinColor from '../../../../../../../../theme/Color';
import { LightTooltip } from '../../../../../../../shared/CustomTooltip/CustomTooltip';

export const RoleNameCell = ({ row, column }: { row: any; column: RolesColumn }) => {
  return (
    <LightTooltip
      title={
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '16px',
          }}
        >
          <Typography variant='heading4' color={zeplinColor.Neutral1} sx={{ marginBottom: '12px' }}>
            Assigned Permissions
          </Typography>
          <Typography variant='body3' color={zeplinColor.Neutral1} sx={{ marginBottom: '8px' }}>
            Dashboard:
          </Typography>
          <Typography variant='body3' color={zeplinColor.Neutral1}>
            View Activity, View Task, Edit Task, Delete Task, View Calendar
          </Typography>
        </Box>
      }
      placement='bottom-start'
      style={{
        backgroundColor: zeplinColor.BasicBlack,
        borderRadius: '8px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        {row[column.id as keyof typeof row]}
        <ShieldKeyIcon />
      </Box>
    </LightTooltip>
  );
};
